import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const CookiesAllowedActions = createActionGroup({
  source: 'Cookies Allowed Local Storage',
  events: {
    Load: emptyProps(),
    'Set Current State': props<{ isAllowedCookies: boolean }>(),
    'Set Current State Modal': props<{ isCookiesPolicyModalVisible: boolean }>(),
    'Update State': props<{ isAllowedCookies: boolean }>(),
  },
});
